<template>
  <div class="training content">
    <TrainingPage />
    <TrainingList />
  </div>
</template>


<script>
import TrainingList from '@/components/TrainingList.vue'
import TrainingPage from '@/components/TrainingPage.vue'

export default {
  name: 'home',
  components: {
    TrainingList,
    TrainingPage
  },
  mounted: function () {
    this.$store.dispatch('LOAD_TRAINING_LIST'),
    this.$store.dispatch('LOAD_PAGE', {page: 'training'})
  }
}
</script>
